import React, { createContext, useState, useEffect } from 'react';
import { api } from '../utils/api';

const StudentAchievementContext = createContext();

const StudentAchievementProvider = ({ children }) => {
  const [studentAchievement, setStudentAchievement] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api
      .get('/api/achievements')
      .then((res) => {
        setStudentAchievement(res.documents);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <StudentAchievementContext.Provider value={{ studentAchievement, loading, error }}>
      {children}
    </StudentAchievementContext.Provider>
  );
};

export { StudentAchievementContext, StudentAchievementProvider };
